import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Delta } from 'jsondiffpatch/lib/types';
import { hasLog, normalizeLog } from 'ag-common-svc/lib/components/changes-history-grid/utils/normalize-log';
import { LookupKeys } from '@ag-common-lib/lib/models/crm/lookup.model';
import { GuestEvents, GuestEventsMap } from '@ag-common-lib/lib/models/registration/guest.model';
import { TRUE_FALSE_LOOKUP } from '@ag-common-lib/lib/lists/yes-no.list';

@Component({
  selector: 'ag-shr-change-log-complimentary-configuration-detail',
  templateUrl: './change-log-complimentary-configuration.component.html',
  styleUrls: ['./change-log-complimentary-configuration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeLogComplimentaryConfigurationComponent {
  @Input() log: Delta;

  protected readonly complimentaryConfigurationKeys = [GuestEvents.main, GuestEvents.chairmanExtension];
  protected readonly complimentaryConfigurationLookup = [
    { [LookupKeys.value]: GuestEvents.main, [LookupKeys.description]: GuestEventsMap.get(GuestEvents.main) },
    { [LookupKeys.value]: GuestEvents.chairmanExtension, [LookupKeys.description]: GuestEventsMap.get(GuestEvents.chairmanExtension) },
  ];
  protected readonly complimentaryConfigurationWithLookup = {
    [GuestEvents.main]: TRUE_FALSE_LOOKUP,
    [GuestEvents.chairmanExtension]: TRUE_FALSE_LOOKUP,
  };
  protected readonly hasLog = hasLog;
  protected readonly normalizeLog = normalizeLog;
}
